import React from 'react';
import { Button } from '../../buttons/Button/Button';
import { Modal } from '../Modal/Modal';
import { Sizes } from 'react-bootstrap';
import { RenderProp } from 'utils/handleRenderProp';

export interface ConfirmationModalProps {
    show?: boolean;
    size?: Sizes;
    title?: string | JSX.Element | RenderProp;
    confirmBtnText?: string;
    cancelBtnText?: string;
    confirmDisabled?: boolean;
    cancelDisabled?: boolean;
    onConfirm: () => void;
    onCancel?: () => void;
    onHide?: () => void;
    ref?: React.RefObject<any>;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {

    const emptyFn = () => {};

    return (
        <Modal
            show={props.show}
            size={props.size}
            onHide={props.onHide || props.onCancel || emptyFn}
            title={props.title || 'Confirmation'}
            buttons={() => (
                <>
                    <Button onClick={props.onConfirm} disabled={props.confirmDisabled}>{props.confirmBtnText || 'Confirm'}</Button>
                    <Button onClick={props.onCancel} disabled={props.cancelDisabled}>{props.cancelBtnText || 'Cancel'}</Button>
                </>
            )}
            >
            {props.children || 'Are you sure you want to do this?'}
        </Modal>
    )
}

(ConfirmationModal as any).displayName = 'ConfirmationModal';